import PropTypes from 'prop-types';
import { Box, Typography, Container, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';

export interface SectionHeadingProps {
  heading: string;
  subheading?: string;
  id?: string;
}

export const SectionHeading = ({ heading, subheading, id }: SectionHeadingProps) => {
  return (
    <Container sx={{ px: { xs: 2, md: 4 } }}>
      <Box
        id={id}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            alignItems: 'center',
            pb: 3,
            width: '100%',
            mb: subheading ? 2 : 1,
          }}
        >
          <Typography
            variant='subtitle1'
            sx={{
              color: globalColours['$global-colour-content-primary'],
              width: 'min-content',
              minWidth: '100%',
              textAlign: 'center',
              alignItems: 'center',
            }}
          >
            {heading}
          </Typography>
          {subheading && (
            <Typography
              variant='body2SemiBold'
              sx={{
                color: globalColours['$global-colour-content-secondary'],
                // whiteSpace: 'nowrap',
                maxWidth: { xs: '100%', md: '500px' },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              {subheading}
            </Typography>
          )}
        </Stack>
      </Box>
    </Container>
  );
};

SectionHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  id: PropTypes.string,
};

SectionHeading.defaultProps = {
  subheading: null,
};

export default styled<any>(SectionHeading)(({ theme }) => ``);
